export const formatPrice = (price) => {
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: 'MXN',
  }).format(price);
};

export const formatDate = (date) => {
  return new Date(date).toLocaleDateString('es-MX', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

export const generateOrderNumber = () => {
  const timestamp = Date.now();
  const random = Math.floor(Math.random() * 1000);
  return `ALP-${timestamp}-${random}`;
};

// URL pública de un producto: usa el código corto (X116) y cae al id si no existe
export const productPath = (product) =>
  `/products/${encodeURIComponent(product?.product_code || product?.id)}`;

// Mensajes legibles para errores de validación del backend (FastAPI manda `detail`
// como lista de objetos en un 422; pasarlo directo a un toast tumba la página)
const FIELD_ERROR_MESSAGES = {
  email: 'Revisa que tu correo electrónico esté bien escrito',
  phone: 'Tu teléfono debe tener 10 dígitos',
  name: 'Escribe tu nombre (mínimo 2 letras)',
  city: 'Escribe tu ciudad',
};

export const apiErrorMessage = (data, fallback) => {
  const detail = data?.detail;
  if (typeof detail === 'string' && detail) return detail;
  if (Array.isArray(detail) && detail.length > 0) {
    const field = detail[0]?.loc?.[detail[0].loc.length - 1];
    return FIELD_ERROR_MESSAGES[field] || fallback;
  }
  return fallback;
};
